
//const shortUrl = require('../utils/shorturl');

const TITLE = '¡Nuevas oportunidades de empleo!';
const DESC = 'Postúlate o comparte entre tu red de contactos.';

const url = document.querySelector('meta[name="hr:customer:url"]').getAttribute('content');
const share = document.getElementsByClassName('share_social');
var i;
for (i = 0; i < share.length; i++) {
    share[i].addEventListener('click', function(e) {
        console.log(e.srcElement.className);        
        var screen_width = screen.width;
        var screen_height = screen.height;
        var popup_width = screen_width - (screen_width*0.4);
        var popup_height = screen_height - (screen_height*0.4);
        var left = (screen_width/2)-(popup_width/2);
        var top = (screen_height/2)-(popup_height/2);
        var parameters = 'toolbar=0,status=0,width=' + popup_width + ',height=' + popup_height + ',top=' + top + ',left=' + left;
        return window.open($(this).attr('href'), '', parameters) && false;
    });
}

$(function() {
    $('.icon_share').bind('click', function(e) {
        $(this).prev().toggleClass('hide');          
    });

    //shareButtons();
});

// async function shareButtons () {
//    let device = navigator.userAgent.toLowerCase();
//    let urlTwitter = await shortUrl(`${url}?source=twitter`);
   
//     if (device.search(/iphone|ipod|ipad|webos|android/) > -1) {
//        let urlWhatapp = await shortUrl(`${url}?source=whatsapp`);
       
//        $('.shareVacancy .shareLinks').share({
//            networks: ['facebook', 'googleplus', 'linkedin', 'twitter', 'whatsapp'],
//            theme: 'icon', urlToShare: url, shortUrlWhatsapp: urlWhatapp, shortUrlTwitter: urlTwitter, title: TITLE, desc: DESC, hash: "empleo,trabajo"
//         });
//        return;
//    }
       
//    $('.shareVacancy .shareLinks').share({
//        networks: ['facebook', 'googleplus', 'linkedin', 'twitter'],
//        theme: 'icon', urlToShare: url, shortUrlTwitter: urlTwitter, title: TITLE, desc: DESC, hash: "empleo,trabajo"
//    });
// }